import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import logo1 from "../Assets/img/fantom.png";
import logo2 from "../Assets/logo2.png";
import logo3 from "../Assets/logo3.png";
import logo4 from "../Assets/logo4.png";
import logo5 from "../Assets/logo5.png";
import logo6 from "../Assets/img/ledger.webp";
import logo7 from "../Assets/logo7.png";
import logo8 from "../Assets/logo8.png";
import chorus from "../Assets/img/chorus.png";
const wallets = [
  {
    name: "Metamask",
    logo: logo8,
  },
  {
    name: "WalletConnect",
    logo: logo3,
    alt: true,
  },
  {
    name: "Coinbase Wallet",
    logo: logo4,
  },
  {
    name: "Ledger",
    logo: logo6,
  },
  {
    name: "Phantom ",
    logo: logo1,
  },
  {
    name: "Trezor",
    logo: logo7,
  },

  {
    name: "Keplr",
    logo: logo2,
  },

  {
    name: "OKX",
    logo: logo5,
  },
];

export default function ConnectWalletModal({
  isOpen,
  onClose,
  setShowModal2,
  setShowModal3,
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="relative w-full max-w-md p-4 text-white bg-[#17828D] rounded-lg shadow-xl md:max-w-2xl"
          >
            <button
              className="absolute text-white top-3 right-3 hover:text-white"
              onClick={onClose}
            >
              <FaTimes />
            </button>

            <div className="flex flex-col items-center">
              <img src={chorus} className="mb-2 rounded-full w-9" alt="" />
              <p className="mb-5 text-sm text-center text-white">
                Connect with Chorus
              </p>
            </div>

            <div className="grid grid-cols-1 gap-3">
              {wallets.map((wallet, i) => (
                <button
                  key={i}
                  onClick={() => {
                    if (wallet?.alt) {
                      onClose();
                      setShowModal3(true);
                    } else {
                      onClose();
                      setShowModal2(true);
                    }
                  }}
                  className="w-full flex items-center gap-3 px-4 py-2 bg-[#fff] hover:bg-[#e5dfdf] rounded-md transition text-white"
                >
                  <img
                    src={wallet.logo}
                    alt={wallet.name}
                    className="rounded h-9 w-9"
                  />
                  <span className="text-sm text-black">{wallet.name}</span>
                </button>
              ))}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
